<section [formGroup]="getFormGroup()" id="filter">
  <div class="row justify-content-between">
    @if (display().includes("organizations")) {
    <div [ngClass]="setColumns()" class="flex-align-items-baseline space-between mb-2 mb-md-0">
      <label class="mr-1" for="organisation">{{ 'organization' | translate | titlecase }}</label>
      <ng-select
        [items]="filterValues().organizations"
        bindLabel="name"
        [multiple]="multiple().includes('organizations')"
        class="w-100"
        formControlName="organizations"
        placeholder="{{ 'SelectAllFemaleGenre' | translate }}"
      />
    </div>
    } @if (display().includes("tags")) {
    <div [ngClass]="setColumns()" class="flex-align-items-baseline space-between mb-2 mb-md-0">
      <label class="mr-1" for="tags">{{ 'tag' | translate | titlecase }}</label>
      <ng-select
        [items]="filterValues().tags"
        [multiple]="multiple().includes('tags')"
        class="w-100"
        formControlName="tags"
        placeholder="{{ 'SelectAllMaleGenre' | translate }}"
      />
    </div>
    } @if (display().includes("clusters")) {
    <div [ngClass]="setColumns()" class="flex-align-items-baseline space-between">
      <label class="mr-1" for="tags">{{ 'cluster' | translate | titlecase }}</label>
      <ng-select
        [items]="filterValues().clusters"
        bindLabel="name"
        [multiple]="multiple().includes('clusters')"
        class="w-100"
        formControlName="clusters"
        placeholder="{{ 'SelectAllMaleGenre' | translate }}"
      />
    </div>
    }
  </div>
</section>
